import type { InputHTMLAttributes, ReactNode, Ref } from "react";
import "./checkbox.css";

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, "id" | "type" | "name" | "value" | "checked" | "onChange" | "aria-describedby"> & {
  id: string;
  /** Lo stesso `name` per tutti i pallini della stessa scelta, anche in celle diverse. */
  name: string;
  value: string;
  /** Il nome del pallino (anche composto): tutto il testo è il nome. */
  label: ReactNode;
  checked: boolean;
  /** Il pallino è stato scelto. */
  onChange: () => void;
  /** L'`id` di un testo scritto altrove che spiega il pallino (per esempio perché è spento). */
  describedBy?: string;
  className?: string;
  /** Arriva all'`<input>` (in React 19 `ref` è una prop). */
  ref?: Ref<HTMLInputElement>;
};

// Un pallino solo, con la sua etichetta: per le scelte che non stanno in un gruppo unico, come i pallini della
// stessa riga sparsi in colonne diverse di una tabella (il campo da tenere fra due Lead). Il nome della scelta lo
// dà la riga (`<th scope="row">`). Quando le scelte stanno insieme si usa `RadioGroup`, che ha il suo titolo.
export function Radio({ id, name, value, label, checked, onChange, disabled, describedBy, className, ...rest }: Props) {
  return (
    <div className={className ? `g-check ${className}` : "g-check"} data-disabled={disabled ? "true" : undefined}>
      <input
        id={id}
        {...rest}
        type="radio"
        className="g-check__input"
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        aria-describedby={describedBy}
        onChange={() => onChange()}
      />
      <label className="g-check__label" htmlFor={id}>{label}</label>
    </div>
  );
}
